import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { getAccessToken } from "@/services/api"

const BASE_URL = import.meta.env.VITE_API_BASE_URL || "http://localhost:9080/api/v1"
const VISITOR_ID_KEY = "analytics_visitor_id"

export function getAnalyticsVisitorID(): string {
  let visitorID = localStorage.getItem(VISITOR_ID_KEY)
  if (!visitorID) {
    visitorID = crypto.randomUUID()
    localStorage.setItem(VISITOR_ID_KEY, visitorID)
  }
  return visitorID
}

// Peta path → label menu untuk laporan agregat.
// Urutan penting: pola paling spesifik dicek lebih dulu.
const MENU_RULES: { test: RegExp; menu: string }[] = [
  { test: /^\/panduan\/racikan$/, menu: "Racikan Obat" },
  { test: /^\/panduan\/[^/]+$/, menu: "Panduan — Detail" },
  { test: /^\/panduan$/, menu: "Panduan" },
  { test: /^\/penyakit\/[^/]+$/, menu: "Penyakit — Detail" },
  { test: /^\/penyakit$/, menu: "Penyakit" },
  { test: /^\/vaksinasi\/[^/]+$/, menu: "Vaksinasi — Detail" },
  { test: /^\/vaksinasi$/, menu: "Vaksinasi" },
  { test: /^\/jenis-ayam\/[^/]+$/, menu: "Jenis Ayam — Detail" },
  { test: /^\/jenis-ayam$/, menu: "Jenis Ayam" },
  { test: /^\/penipu\/[^/]+$/, menu: "Penipu — Detail" },
  { test: /^\/penipu$/, menu: "Penipu" },
  { test: /^\/etalase\/[^/]+$/, menu: "Etalase — Detail" },
  { test: /^\/etalase$/, menu: "Etalase" },
  { test: /^\/racik-pakan$/, menu: "Racik Pakan" },
  { test: /^\/harga-komoditas$/, menu: "Harga Komoditas" },
  { test: /^\/trending\/[^/]+$/, menu: "Trending" },
  { test: /^\/profil$/, menu: "Profil" },
  { test: /^\/menu$/, menu: "Menu" },
  { test: /^\/kategori$/, menu: "Kategori" },
  { test: /^\/faq$/, menu: "FAQ" },
  { test: /^\/tentang$/, menu: "Tentang" },
  { test: /^\/privacy-policy$/, menu: "Privacy Policy" },
  { test: /^\/terms-conditions$/, menu: "Terms & Conditions" },
  { test: /^\/login$/, menu: "Login" },
  { test: /^\/register$/, menu: "Register" },
  { test: /^\/verify-email$/, menu: "Verifikasi Email" },
  { test: /^\/forgot-password$/, menu: "Lupa Password" },
  { test: /^\/reset-password$/, menu: "Reset Password" },
  { test: /^\/$/, menu: "Beranda" },
]

export function menuLabel(path: string): string {
  for (const rule of MENU_RULES) {
    if (rule.test.test(path)) return rule.menu
  }
  return "Lainnya"
}

// Kirim catatan kunjungan. Fire-and-forget: kegagalan tidak pernah
// mengganggu UI, dan `keepalive` menjaga request tetap terkirim saat
// pengguna langsung pindah halaman.
export function trackPageView(path: string, referrer = document.referrer) {
  const token = getAccessToken()
  const headers: Record<string, string> = { "Content-Type": "application/json" }
  if (token) headers["Authorization"] = `Bearer ${token}`

  fetch(`${BASE_URL}/track`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      path,
      menu: menuLabel(path),
      referrer,
      visitor_id: getAnalyticsVisitorID(),
    }),
    keepalive: true,
  }).catch(() => {})
}

// Dipasang sekali di App: mencatat tiap perpindahan route.
// Halaman /admin sengaja TIDAK dicatat (aktivitas admin, bukan perilaku user).
export function usePageTracking(enabled = true) {
  const location = useLocation()

  useEffect(() => {
    if (!enabled || location.pathname.startsWith("/admin")) return
    // tunda sedikit supaya tidak bersaing dengan render/fetch halaman
    const t = setTimeout(() => trackPageView(location.pathname), 300)
    return () => clearTimeout(t)
  }, [enabled, location.pathname])
}
